import { useGenStore } from 'stores/useGenStore';
import screenAndStyle from '../_utils/screen-and-style';

const getValidatedTypes = () => {
  const { isSafariPrivate } = useGenStore.getState();
  const isProjectEditPage = window?.location?.href?.includes('project_edit') ?? false;
  const hasIndexedDbUploader = !!window?.featureFlags?.indexed_db_uploader;
  const isMobile = screenAndStyle.isMobileBrowser();

  /* NOTE: Change `app/lib/image_processors/mime_validator.rb` to match up with any changes made to ACCEPTED_FILE_TYPES */
  const acceptedFileTypes =
    isProjectEditPage && hasIndexedDbUploader && !isSafariPrivate && !isMobile
      ? ['image/jpeg', 'image/png', 'image/avif', 'image/heif', 'image/heic', ...(isMobile ? [] : ['.pdf', 'application/pdf']) ]
      : ['image/jpeg', 'image/png'];

  const validFileTypes =
    isProjectEditPage && hasIndexedDbUploader && !isSafariPrivate
      ? [
          '.jpg',
          '.jpeg',
          'image/jpeg',
          'image/png',
          '.png',
          '.avif',
          'image/avif',
          '.heif',
          'image/heif',
          '.heic',
          'image/heic',
          ...(isMobile ? [] : ['.pdf', 'application/pdf']),
        ]
      : ['.jpg', '.jpeg', 'image/jpeg', 'image/png', '.png'];

  return { acceptedFileTypes, validFileTypes };
};

/**
 * Represents a validator for image upload files.
 */
class ImageUploadFileValidator {
  constructor() {}

  /**
   * Gets the string representation of accepted file types.
   * @returns {string} The string representation of accepted file types.
   */
  get acceptFileTypeString() {
    const { validFileTypes } = getValidatedTypes();

    let fileTypes = validFileTypes;
    return fileTypes;
  }

  /**
   * Checks if the given file is an accepted file type.
   * @param {File} file - The file to be checked.
   * @returns {boolean} True if the file is an accepted file type, false otherwise.
   */
  isAcceptedFileType(file) {
    const { acceptedFileTypes } = getValidatedTypes();

    return acceptedFileTypes.indexOf(file.type) > -1;
  }
}

export default ImageUploadFileValidator;
